// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1sM5V","buttons":"SendReceipts_buttons__15wy0","email":"SendReceipts_email__2Zrb4","bookApptTitle":"SendReceipts_bookApptTitle__2dBqg"};